import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, icon, iconColor, subtitle }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-5 shadow-warm transition-smooth hover:shadow-warm-md">
      <div className="flex items-center gap-3 md:gap-4 mb-2 md:mb-3">
        <div 
          className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={20} color={iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground mb-1">{title}</p>
          <h4 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground">{value}</h4>
        </div>
      </div>
      {subtitle && (
        <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default MetricsCard;